import { Schema } from "effect";

// Agent entity IDs - prevent mixing different agent-related IDs

export const AgentId = Schema.String.pipe(
  Schema.brand("AgentId")
);
export type AgentId = typeof AgentId.Type;

export const AgentRunId = Schema.String.pipe(
  Schema.brand("AgentRunId")
);
export type AgentRunId = typeof AgentRunId.Type;

export const AgentTemplateId = Schema.String.pipe(
  Schema.brand("AgentTemplateId")
);
export type AgentTemplateId = typeof AgentTemplateId.Type;

export const ClusterId = Schema.String.pipe(
  Schema.brand("ClusterId")
);
export type ClusterId = typeof ClusterId.Type;

export const ConnectionId = Schema.String.pipe(
  Schema.brand("ConnectionId")
);
export type ConnectionId = typeof ConnectionId.Type;

export const SentryConnectionId = Schema.String.pipe(
  Schema.brand("SentryConnectionId")
);
export type SentryConnectionId =
  typeof SentryConnectionId.Type;
